export const linkLenguages = [
    {
        label: 'Português (BR)',
        value: 'pt_BR',
        show: true
    },
    {
        label: 'English (US)',
        value: 'en_US',
        show: true
    },
    // {
    //     label: 'Español',
    //     value: 'es_ES',
    //     show: true
    // }
]